import { Type } from '@angular/core';

export class SurveyStatisticsItem {
    constructor(public component: Type<any>, public statistics: any) {
    }
}
